import { useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { globalContext } from 'context/global';

/**
 * This custom useHistory hook adds mfe path information
 * to history methods.
 */
export const useHistoryWithHost = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { path: mfPath } = useContext(globalContext);
  return {
    push: (path: string, state?: any) =>
      navigate(`${mfPath}${path}`, { state }),
    replace: (path: string, state?: any) =>
      navigate(`${mfPath}${path}`, { replace: true, state }),
    goBack: () => navigate(-1),
    goForward: () => navigate(1),
    location,
  };
};
